<template>
  <div class="c-intro" v-html="html"></div>
</template>

<script>
export default {
  props: {
    html: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped lang="less">
.c-intro {
  width: 100%;
  padding: 50px 32px;
  box-sizing: border-box;
  font-size: 30px;
  line-height: 2.2;
  letter-spacing: 1px;
}
</style>